import EventTeaser from 'components/Teasers/SmallEvent'
import styles from './ComplimentaryEvents.module.scss'

export default function ComplimentaryEvents({ section }) {
  if (!section || section.events.length === 0) {
    return null
  }

  const { title, events } = section

  return (
    <section className={styles.section}>
      {title && <h5 className={styles.title}>{title}</h5>}
      {events.map((event) => (
        <EventTeaser event={event} key={event.id} />
      ))}
    </section>
  )
}
